module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "15px 5%",
      "justify-content": "center"
    }
  }, [(_vm.submissionToOpen) ? _c('IndividualSubmissionOverlay', {
    key: "individual-submission-overlay",
    attrs: {
      "submission_id": _vm.submissionToOpen
    },
    on: {
      "close": function($event) {
        _vm.submissionToOpen = ''
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [(_vm.usePlaceholder) ? _c('div', [_c('h1', [_vm._v("Keyword Cloud")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin": "30px 0"
    },
    attrs: {
      "src": "/static/cloud_empty.png",
      "alt": "No Words"
    }
  })]) : _c('div', [_c('table', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "padding-left": "30px"
    }
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "35%",
      "font-size": "12px",
      "text-align": "left",
      "vertical-align": "middle"
    }
  }, [(_vm.showEditKeywordsButton) ? _c('span', {
    staticStyle: {
      "margin-bottom": "50px",
      "cursor": "pointer",
      "font-size": "15px"
    },
    on: {
      "click": function($event) {
        _vm.clickEditKeywords = true
      }
    }
  }, [_vm._v("Edit Keywords")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "font-size": "15px",
      "float": "right",
      "margin-bottom": "3px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.wordCloudLanguage) + "\n            ")])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "103%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('vue-word-cloud', {
    staticStyle: {
      "margin": "0 auto"
    },
    style: ({
      width: _vm.wordCloudWidth,
      height: '400px',
    }),
    attrs: {
      "spacing": 0.2,
      "font-size-ratio": 5,
      "words": _vm.wordCloudData,
      "color": function (ref) {
          var sent = ref[2];

          return sent === 'blu' ?
        '#72CCD7' :
        sent === 'red' ?
        '#EB2D7C' :
        '#273248';
  },
      "font-family": "Helvetica",
      "font-weight": "Bold"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var text = ref.text;
        var weight = ref.weight;
        var word = ref.word;

        return [_c('div', {
          style: ('cursor: pointer; opacity: ' +
            (_vm.selectedWordData === null ?
              '1' :
              _vm.selectedWordData.word === text ?
              '1' :
              '0.15')),
          attrs: {
            "title": weight
          },
          on: {
            "click": function($event) {
              return _vm.onWordClick(text)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(text) + "\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    nativeOn: {
      "click": function($event) {
        _vm.show_info = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), (_vm.show_info) ? _c('pl-dialog', {
    attrs: {
      "header": "The Idea Cloud analyzes the RoundTable for frequent words across student submissions."
    },
    on: {
      "close": function($event) {
        _vm.show_info = false
      }
    }
  }, [_c('p', {
    staticClass: "italics pl-subheading tc"
  }, [_vm._v("\n                The bigger the word in the cloud, the more times it was used!\n              ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('section', {
    staticClass: "flex justify-center items-center ma3"
  }, [_c('p', {
    staticClass: "mr3 pl-caption"
  }, [_vm._v("\n                  Share this visual and become a\n                  "), _c('b', {
    staticClass: "link-to-blog",
    on: {
      "click": _vm.toBlogPost
    }
  }, [_vm._v("Parlay Trailblazer!")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "social-icons clickable",
    attrs: {
      "src": "/static/shareOnTW.svg",
      "alt": "Share on Twitter"
    },
    on: {
      "click": _vm.shareOnTW
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "social-icons clickable",
    attrs: {
      "src": "/static/shareOnFB.svg",
      "alt": "Share on Facebook"
    },
    on: {
      "click": _vm.shareOnFB
    }
  })])]) : _vm._e(), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.show_info = false
      }
    }
  }, [_vm._v("\n                OK\n              ")])], 1) : _vm._e()], 1)])]), _vm._v(" "), (_vm.openDialog) ? _c('div', [_c('table', {
    staticStyle: {
      "display": "block",
      "width": "104%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "text-align": "left",
      "margin": "30px 0 18px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.selectedWordData.word) + " (" + _vm._s(_vm.selectedWordData.sentences.length) + ")\n              ")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "0"
    }
  })])]), _vm._v(" "), _vm._l((_vm.selectedWordData.sentences), function(sent) {
    return _c('div', {
      staticClass: "sentence-card"
    }, [(
      _vm.hasTeacherPermissionsInCourse ||
      (!_vm.hasTeacherPermissionsInCourse && !sent.is_hidden) ||
      (_vm.ownSentence(sent.userId) && sent.is_hidden)
    ) ? _c('div', {
      class: [sent.is_hidden ? 'hidden-record' : '']
    }, [_c('table', {
      staticStyle: {
        "display": "block",
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticClass: "profile-pic",
      staticStyle: {
        "float": "left",
        "margin-left": "10px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "22px",
        "height": "22px",
        "border-radius": "50%"
      },
      attrs: {
        "src": _vm.getUserAvatar(sent.userId),
        "alt": "Profile-Picture"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('p', {
      staticStyle: {
        "font-weight": "normal",
        "font-size": "12px"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.getUserName(sent.userId)) + "\n                    ")])])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "0"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left",
        "padding": "0 15px 10px",
        "overflow-wrap": "break-word"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getSentence(sent.sentence))
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#7fd3de",
        "padding": "0 15px 10px"
      },
      attrs: {
        "id": "submission-link"
      },
      on: {
        "click": function($event) {
          return _vm.redirectToSubmission(sent.userId, sent)
        }
      }
    }, [_vm._v("View in Context")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "8px"
      }
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.showHiddenMessage) ? _c('div', [_c('span', [_vm._v(" This word is related to 1 or more hidden submissions ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer",
      "width": "100%",
      "margin-bottom": "10px",
      "margin-top": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.closeList()
      }
    }
  }, [_vm._v("\n          Close\n        ")])], 2) : _vm._e()])]), _vm._v(" "), (_vm.clickEditKeywords) ? _c('roundtableNlpWordCloudEditKeywords', {
    attrs: {
      "keywords": _vm.keywordData
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "55%"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-bottom": "30px",
      "text-align": "left"
    }
  }, [_vm._v("\n              Keyword Cloud\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("language")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6416f656!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableNlpWordCloud.vue
// module id = 1246
// module chunks = 61